import { Connector, Button } from '@schibsted-svp/react-ui';

import styles from './DataSourceModeSwitch.module.scss';

type DataSourceMode = 'preset' | 'endpoint';

type Props = {
  value: DataSourceMode;
  onChange: (mode: DataSourceMode) => void;
};

/**
 * C-DSM: two-segment switch letting editors pick between curated preset items
 * and a fetched endpoint for dual-mode data types. Purely UI-only — the
 * selected mode is stored in the transient `data.dataSourceMode` field and
 * never reaches the API payload.
 */
function DataSourceModeSwitch({ value, onChange }: Props) {
  return (
    <div className={styles.container}>
      <Connector gap={1}>
        <Button
          type="button"
          variant="standard"
          size="compact"
          selected={value === 'preset'}
          aria-pressed={value === 'preset'}
          onClick={() => onChange('preset')}
          data-testid="data-source-mode-preset"
        >
          Preset items
        </Button>
        <Button
          type="button"
          variant="standard"
          size="compact"
          selected={value === 'endpoint'}
          aria-pressed={value === 'endpoint'}
          onClick={() => onChange('endpoint')}
          data-testid="data-source-mode-endpoint"
        >
          Endpoint
        </Button>
      </Connector>
    </div>
  );
}

export { DataSourceModeSwitch };
